<style scoped>
/deep/.el-drawer__header {
  margin-bottom: 10px !important;
}
.arrive-detail-title {
  margin-bottom: 30px;
}
/deep/.el-progress {
  float: left;
  width: 80%;
}
.cost-detail-item {
  display: flex;
  padding: 30px;
}
.ticket-inform {
  padding: 20px;
}
.ticket-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.ticket-item {
  display: flex;
  text-align: left;
  margin-bottom: 15px;
}
.ticket-right {
  /* width: 120px; */
  /* height: 70px; */
  /* border: 1px solid#dcdfe6; */
  margin-top: 28px;
}
.ticket-right img {
  width: 120px;
  height: 70px;
}
/deep/ .image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 16px;
}
.el-button--info{
  font-size: 12px;
}
iframe img{
  width: 100%;
}
</style>
<template>
  <div>
    <el-drawer :title="title" :visible.sync="showFillDetail" :direction="direction" size="40%">
      <div class="information">
        <div class="fill-detail-title">
          <p class="t-left font-S18">{{ fillDetail.supplierName }}</p>
          <p class="t-left">{{ fillDetail.month }}</p>
        </div>
        <div class="cost-ratio mb30">
          <div class="cost-item font-S12 mb30 mt30">
            <p class="t-left">SPD运营费用：¥{{ fillDetailData.payableAmount | numDigit }}元</p>
            <div class="cost-progress">
              <el-progress :text-inside="true" :stroke-width="15" :percentage="setSpdProgress()"></el-progress>
              <span class="cost-name">已到账</span>
            </div>
          </div>
          <div class="cost-item font-S12 mb50 mt30">
            <p class="t-left">发票：¥{{ fillDetailData.receiptAmount | numDigit }}元</p>
            <div class="cost-progress">
              <el-progress :text-inside="true" :stroke-width="15" :percentage="setInvoiceProgress()"></el-progress>
              <span class="cost-name">已开票</span>
            </div>
          </div>
        </div>
        <div class="cost-detail mb30">
          <div class="cost-detail-item border-d6 mb15" v-for="(item, index) in trOperatingReceiptAmounts" :key="index">
            <div class="cost-date mr50">
              <span class="inform-title">付款日期：</span>
              <span>{{ item.receiptDate | getDate }}</span>
            </div>
            <div class="cost-money">
              <span class="inform-title">到账款：</span>
              <span>{{ item.receiptAmount | numDigit }}元</span>
            </div>
          </div>
        </div>
        <div class="ticket-inform mb30 border-d6" v-for="(item, index) in trOperatingInvoices" :key="index">
          <p class="t-left font-S16">{{ item.invoiceType | getInvoiceType }}</p>
          <div class="ticket-content">
            <div class="ticket-left">
              <div class="ticket-item">
                <span class="inform-title">开票日期: </span
                ><span class="inform-content">{{ item.invoiceDate | getDate }}</span>
              </div>
              <div class="ticket-item">
                <span class="inform-title">发票号: </span><span class="inform-content">{{ item.invoiceNo }}</span>
              </div>
              <div class="ticket-item">
                <span class="inform-title">开票金额: </span
                ><span class="inform-content">{{ item.invoiceAmount | numDigit }}元</span>
              </div>
            </div>
            <div class="ticket-right borderR6">
              <el-button type="info" size="small" @click="getPdf(item.scanCopy)">点击查看附件</el-button>
              <!-- <el-image
                class="borderR6"
                style="width: 100%; height: 100%"
                :src="item.scanCopy"
                :preview-src-list="srcList"
              >
                <div slot="error" class="image-slot">
                  暂无图片
                </div>
              </el-image> -->
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
    <el-dialog
      title="附件查看"
      :visible.sync="getPdfFile"
      fullscreen
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <div class="el-dialog-div">
        <iframe :src="pdfSrc" frameborder="0" style="width: 100%; height: 100%"></iframe>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ['fillDetailData'],
  data() {
    return {
      title: '填报详情',
      showFillDetail: false,
      direction: 'rtl',
      trOperatingReceiptAmounts: [], //到账
      fillDetail: {},
      trOperatingInvoices: [], //发票
      srcList: [],
      getPdfFile: false,
      pdfSrc: '',
    };
  },
  created() {},
  methods: {
    //设置SPD进度条
    setSpdProgress() {
      let self = this;
      let hasProgress = Number(
        ((self.fillDetailData.receiptAmount / self.fillDetailData.payableAmount) * 100).toFixed(2),
      );
      if (Number(self.fillDetailData.receiptAmount) > Number(self.fillDetailData.payableAmount)) {
        return 100.00;
      } else if (self.fillDetailData.receiptAmount && self.fillDetailData.payableAmount) {
        return hasProgress;
      } else {
        return 0;
      }
    },
    //设置发票进度条
    setInvoiceProgress() {
      let self = this;
      let hasProgress = Number(
        ((self.fillDetailData.invoiceAmount / self.fillDetailData.receiptAmount) * 100).toFixed(2),
      );
      if (Number(self.fillDetailData.invoiceAmount) > Number(self.fillDetailData.payableAmount)) {
        return 100.00;
      } else if (Number(self.fillDetailData.invoiceAmount) && Number(self.fillDetailData.receiptAmount)) {
        return hasProgress;
      } else {
        return 0;
      }
    },
    //对到账填报数据进行日期排序
    sortReceiptDateArray(dataArray) {
      const self = this;
      return dataArray.sort((a, b) => {
        return self.$moment(b.receiptDate).unix() - self.$moment(a.receiptDate).unix();
      });
    },
    //对发票填报数据进行日期排序
    sortInvoiceDateArray(dataArray) {
      const self = this;
      return dataArray.sort((a, b) => {
        return self.$moment(b.invoiceDate).unix() - self.$moment(a.invoiceDate).unix();

      });
    },
    //发票填报详情
    getInvoiceDetail(operatingCostsGuid) {
      let self = this;
      self.api
        .get('/ms-data-business-service/operating-invoice/get-operating-info?operatingCostsGuid=' + operatingCostsGuid)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.fillDetail = res.data.data;
            self.trOperatingReceiptAmounts = self.sortReceiptDateArray(res.data.data.trOperatingReceiptAmounts);
            self.trOperatingInvoices = self.sortInvoiceDateArray(res.data.data.trOperatingInvoices);
            if (self.trOperatingInvoices !== null) {
              self.trOperatingInvoices.forEach((item) => {
                item.scanCopy = JSON.parse(item.scanCopy);
                self.srcList.push(item.scanCopy);
              });
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //点击查看pdf
    getPdf(scanCopy) {
      let self = this;
      if (!scanCopy) {
        return;
      }
      self.getPdfFile = true;
      if (self.trOperatingInvoices == '' || self.trOperatingInvoices == null || self.trOperatingInvoices == undefined) {
        self.pdfSrc = '';
      } else {
        self.pdfSrc = scanCopy;
      }
    },
  },
};
</script>